<template>
  <div class="sp-finder-map-surface map" :style="layoutStyle">
    <div id="doctor-map-container" ref="canvas" :style="canvasStyle" :data-testid="TestId.finder.mapContainer">
      <sp-google-map
        id="doctor-map"
        v-preserve-properties:options="options"
        :api-key="settings?.apiKey"
        :api-version="settings?.apiVersion"
        style="height: 100%; min-height: 0"
        @viewport-change="viewportChanged"
        @map-ready="ready"
        @map-error="failed"
        @map-dispose="disposed"
      ></sp-google-map>
      <FinderMapBoundsControl :viewport="viewport" :enabled="Boolean(settings?.boundsScopingEnabled)" />
      <p v-if="error" role="alert">{{ mapText("load_error") }}</p>
    </div>
    <FinderMapSidebar
      ref="sidebar"
      :records="records"
      :kind="kind"
      :payload="payload"
      :settings="cardSettings"
      :loading="loading"
      :commands="commands"
      :params="params"
      :viewport="viewport"
      :map-settings="settings"
      :selected-guid="selection?.resultGUID"
      @highlight="highlight"
      @unhighlight="unhighlight"
    />
    <Teleport v-if="content" :to="infoTarget"><FinderMapInfoWindow :content="content" /></Teleport>
  </div>
</template>

<script setup>
import { useTemplateRef } from "vue";
import { vPreserveProperties } from "#ce/utils/property-bindings";
import { TestId } from "#/test-ids";
import { mapText } from "#ce/apps/SpFinderMap/lib/map-text";
import { useFinderMapSurface } from "#ce/apps/SpFinderMap/composables/useFinderMapSurface";
import FinderMapBoundsControl from "./FinderMapBoundsControl.ce.vue";
import FinderMapSidebar from "./FinderMapSidebar.ce.vue";
import FinderMapInfoWindow from "./FinderMapInfoWindow.ce.vue";
const props = defineProps({
  records: { type: Array, default: undefined },
  kind: { type: Object, default: undefined },
  payload: { type: Object, default: undefined },
  settings: { type: Object, default: undefined },
  cardSettings: { type: Object, default: undefined },
  selection: { type: Object, default: undefined },
  commands: { type: Object, default: undefined },
  loading: Boolean,
  params: { type: Object, default: undefined },
  generation: { type: Number, default: undefined },
  mode: {
    type: String,
    default: undefined,
    validator: (value) => value === undefined || ["auto", "manual"].includes(value),
  },
});
const canvasStyle = Object.freeze({
  position: "sticky",
  top: "var(--finder-map-offset)",
  height: "calc(100vh - var(--finder-map-offset))",
});
const {
  layoutStyle,
  options,
  viewport,
  error,
  content,
  infoTarget,
  viewportChanged,
  ready,
  failed,
  disposed,
  highlight,
  unhighlight,
} = useFinderMapSurface(props, { canvas: useTemplateRef("canvas"), sidebar: useTemplateRef("sidebar") });
</script>
